import { useEffect } from "react";
import Lenis from "lenis";

export const SmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, lerp: 0.09, anchors: { offset: -80 } });
    return () => {
      lenis.destroy();
    };
  }, []);
  return null;
};
